import { type CAPITAL_PARTNER_NETWORK_CONTENT } from '../content';
import {
  CardGrid,
  ContentContainer,
  Section,
  SectionEyebrow,
  SectionIntro,
  SectionLead,
  SectionTitle,
  SurfaceCard,
  SurfaceText,
  SurfaceTitle,
} from '../styles';

type InvestorBenefitsCopy = (typeof CAPITAL_PARTNER_NETWORK_CONTENT)['investorBenefits'];

type InvestorBenefitsSectionProps = {
  copy: InvestorBenefitsCopy;
};

export default function InvestorBenefitsSection({
  copy,
}: InvestorBenefitsSectionProps) {
  return (
    <Section $emphasis>
      <ContentContainer>
        <SectionIntro $wide>
          <SectionEyebrow>{copy.eyebrow}</SectionEyebrow>
          <SectionTitle>{copy.title}</SectionTitle>
          <SectionLead>{copy.body}</SectionLead>
        </SectionIntro>
        <CardGrid $columns={4}>
          {copy.benefits.map((benefit) => (
            <SurfaceCard key={benefit.title}>
              <SurfaceTitle>{benefit.title}</SurfaceTitle>
              <SurfaceText>{benefit.body}</SurfaceText>
            </SurfaceCard>
          ))}
        </CardGrid>
      </ContentContainer>
    </Section>
  );
}
